import React from "react";
import CleanNavBar from "../Layout/CleanNavBar";
import CleanFooter from "../Layout/CleanFooter";

const CookiePolicy = () => {
  return (
    <div className="page-wrapper">
      <CleanNavBar />
      <div className="page-content">
        <div className="page-header">
          <h1>Cookie Policy</h1>
        </div>
        <div className="clean-container">
          <div className="content-section">
            <p className="last-updated">Last updated: January 2025</p>
            
            <h2>What Are Cookies</h2>
            <p>
              Cookies are small text files stored on your device when you visit our website. They help us 
              provide a better user experience and understand how our services are used.
            </p>
            
            <h2>How We Use Cookies</h2>
            
            <h3>Essential Cookies</h3>
            <p>
              Required for website functionality, including user authentication and security features.
            </p>
            
            <h3>Analytics Cookies</h3>
            <p>
              Help us understand website usage patterns and improve our services. We use Google Analytics 
              to track anonymized visitor statistics.
            </p>
            
            <h3>Marketing Cookies</h3>
            <p>
              Used to deliver relevant advertisements and track campaign effectiveness across platforms 
              like LinkedIn and Google Ads.
            </p>
            
            <h3>Preference Cookies</h3>
            <p>
              Remember your settings and preferences for future visits, including language and region settings.
            </p>
            
            <h2>Cookie List</h2>
            <table className="cookie-table">
              <tr>
                <th>Cookie Name</th>
                <th>Purpose</th>
                <th>Duration</th>
              </tr>
              <tr>
                <td>_ga</td>
                <td>Google Analytics tracking</td>
                <td>2 years</td>
              </tr>
              <tr>
                <td>_gid</td>
                <td>Google Analytics session</td>
                <td>24 hours</td>
              </tr>
              <tr>
                <td>li_mc</td>
                <td>LinkedIn marketing</td>
                <td>6 months</td>
              </tr>
              <tr>
                <td>globe_session</td>
                <td>User session management</td>
                <td>Session</td>
              </tr>
            </table>
            
            <h2>Managing Cookies</h2>
            <p>
              You can control cookies through your browser settings. Note that disabling certain cookies 
              may affect website functionality.
            </p>
            
            <h3>Browser Settings</h3>
            <ul>
              <li>Chrome: Settings → Privacy and security → Cookies</li>
              <li>Firefox: Settings → Privacy & Security → Cookies</li>
              <li>Safari: Preferences → Privacy → Manage Website Data</li>
              <li>Edge: Settings → Privacy, search, and services → Cookies</li>
            </ul>
            
            <h2>Updates to This Policy</h2>
            <p>
              We may update this cookie policy periodically. Check this page for the latest version.
            </p>
            
            <h2>Contact Us</h2>
            <p>
              Questions about our cookie policy? Contact us at: 
              <a href="mailto:privacy@ascendtalentrecruitment.com"> privacy@ascendtalentrecruitment.com</a>
            </p>
          </div>
        </div>
      </div>
      <CleanFooter />
    </div>
  );
};

export default CookiePolicy;